import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g fillOpacity={0.5} opacity={0.9}>
      <path
        fill="url(#Asset_User_svg__a)"
        fillRule="evenodd"
        d="M14.752 16.446c1.052 0 1.933-.843 1.637-1.821-.812-2.681-3.371-4.64-6.402-4.64s-5.59 1.959-6.403 4.64c-.296.978.585 1.821 1.638 1.821z"
        clipRule="evenodd"
      />
      <path
        fill="url(#Asset_User_svg__b)"
        d="M12.846 6.294c0 1.53-1.28 2.769-2.86 2.769-1.578 0-2.858-1.24-2.858-2.769s1.28-2.769 2.859-2.769 2.859 1.24 2.859 2.77Z"
      />
    </g>
    <defs>
      <linearGradient
        id="Asset_User_svg__a"
        x1={14.024}
        x2={-2.127}
        y1={13.014}
        y2={12.678}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_User_svg__b"
        x1={14.024}
        x2={-2.127}
        y1={13.014}
        y2={12.678}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetUser;
